import React, { createContext, Dispatch, ReactNode, SetStateAction, useMemo } from 'react';
import useWorkspaceContext from '../../hooks/context/useWorkspaceContext';
import { Workspace } from '../../types/files';
import storage from '../../utils/storage';

type WorkspaceContextProps = {
  workspace: Workspace | null;
  setWorkspace: Dispatch<SetStateAction<Workspace | null>>;
};

export const WorkspaceContext = createContext<WorkspaceContextProps>({
  workspace: null,
  setWorkspace: () => {},
});

const WorkspaceProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const {
    workspace,
    setWorkspace,
  } = useWorkspaceContext();

  const contextValue = useMemo(() => ({
    workspace,
    setWorkspace,
  }), [
    workspace,
    setWorkspace,
  ]);

  if (storage.getItem('config.logger-context'))
    console.log("CTX", ["Workspace", contextValue]);

  return (
    <WorkspaceContext.Provider value={contextValue}>
      {children}
    </WorkspaceContext.Provider>
  );
};

export default WorkspaceProvider;